// extracted by mini-css-extract-plugin
export var container = "_5w-0";
export var infoButton = "_5w-1";
export var label = "_5w-3";
export var labelExpanded = "_5w-4";
export var price = "_5w-5";
export var priceExpanded = "_5w-6";
export var title = "_5w-2";